import React from "react";
import { Box, Typography } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import useCheckoutClassicStyles from "./checkoutClassicStyles";

export default function BenefitsList({ title, benefits }) {
  const classes = useCheckoutClassicStyles();
  return (
    <Box className={classes.benefitsBlock}>
      <Typography variant="h6" className={classes.sectionTitle}>
        {title}
      </Typography>
      {benefits.map((b, i) => (
        <Box key={i} className={classes.benefitItem}>
          <CheckCircleIcon className={classes.benefitIcon} />
          <Box style={{ flex: 1 }}>
            <Typography className={classes.benefitTitle}>{b.title}</Typography>
            <Typography variant="body2" className={classes.benefitDesc}>
              {b.description}
            </Typography>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
